export default __webpack_public_path__ + "static/media/cursor.136ed28a.cur";